<template>
  <div class="work">
    <h1>心得填寫</h1>
    <h6 style="color: red">不想填的欄位可以留空</h6>
  </div>
  <div class="container">
    <br />
    <div class="form-floating">
      <select class="form-select" id="floatingSelect" v-model="spaSelected">
        <option
          v-for="spaItem in spa"
          v-bind:key="spaItem"
          v-bind:value="{ id: spaItem.id, name: spaItem.name }"
        >
          {{ spaItem.name }}
        </option>
      </select>
      <label for="floatingSelect">店家</label>
    </div>
    <br />
    <h6 style="color: red">名字請勿打錯 下拉選單沒搜尋到代表打錯</h6>
    <h6 style="color: red">請盡量用選的</h6>
    <el-autocomplete
      v-model="name"
      :fetch-suggestions="querySearchAsync"
      placeholder="美容師名稱"
      style="width: 100%"
    ></el-autocomplete>
    <br />
    <br />
    <label style="font-size: 22px; text-align: left; width: 100%">年紀</label>
    <el-input type="textarea" v-model="age" style="font-size: 18px" rows="1" />

    <br />
    <br />
    <label style="font-size: 22px; text-align: left; width: 100%">外型</label>
    <el-input type="textarea" v-model="face" style="font-size: 18px" rows="2" />

    <br />
    <br />
    <label style="font-size: 22px; text-align: left; width: 100%">身材</label>
    <el-input type="textarea" v-model="body" style="font-size: 18px" rows="2" />
    <img src="https://imgf.gg9453.com/images/body.jpg" style="width: 100%" />

    <br />
    <br />
    <label style="font-size: 22px; text-align: left; width: 100%">胸</label>
    <el-input type="textarea" v-model="cup" style="font-size: 18px" rows="1" />

    <br />
    <br />
    <label style="font-size: 22px; text-align: left; width: 100%">膚質膚色</label>
    <el-input type="textarea" v-model="skin" style="font-size: 18px" rows="2" />

    <br />
    <br />
    <label style="font-size: 22px; text-align: left; width: 100%">尺度</label>
    <el-input type="textarea" v-model="interactive" style="font-size: 18px" rows="3" />

    <br />
    <br />
    <label style="font-size: 22px; text-align: left; width: 100%">心得</label>
    <el-input type="textarea" v-model="comment" style="font-size: 18px" rows="5" />

    <br />
    <br />
    <label style="font-size: 22px; text-align: left; width: 100%">填寫者</label>
    <el-input type="textarea" v-model="author" style="font-size: 18px" rows="1" />

    <br />
    <br />
    <label style="font-size: 22px; text-align: left; width: 100%">填寫日期</label>
    <el-input type="textarea" v-model="writeDate" style="font-size: 18px" rows="1" />
    <br />
    <br />
    <label style="font-size: 22px; text-align: left; width: 100%">音樂</label>
    <el-input type="textarea" v-model="music" style="font-size: 18px" rows="1" />
    <br />
    <br />
    <label style="font-size: 22px; text-align: left; width: 100%">體育</label>
    <el-input type="textarea" v-model="sports" style="font-size: 18px" rows="1" />
    <br />
    <br />
    <label style="font-size: 22px; text-align: left; width: 100%">預約時間</label>
    <el-input type="textarea" v-model="reserveDate" style="font-size: 18px" rows="1" />
    <br />
    <p class="h3" style="color: red">為確保心得品質，填寫完畢後請告知幹部</p>
    <button
      type="button"
      class="btn btn-primary"
      :disabled="buttonDisabled"
      @click="doInsert()"
    >
      確定
    </button>
    <p class="h3 text-danger" v-html="getResult"></p>
    <br />
    <br />
    <br />
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      buttonDisabled: false,
      getResult: "&emsp;",
      spa: [
        {
          name: "含香",
          id: "spa_01",
        },
        {
          name: "爵仕堡",
          id: "spa_02",
        },
      ],
      nameSearch: [],
      tableUrl: "/php/spa_table.php",
      configUrl: "/php/spa_config.php",
      spaSelected: "",
      name: "",
      age: "",
      face: "",
      body: "",
      cup: "",
      skin: "",
      interactive: "",
      comment: "",
      author: "",
      writeDate: "",
      music: "",
      sports: "",
      reserveDate: "",
    };
  },
  methods: {
    selectWork3() {
      axios
        .post(this.configUrl, {
          action: "selectWork3",
        })
        .then((res) => {
          this.spa = res.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    selectName(spa_id) {
      axios
        .post(this.tableUrl, {
          action: "selectName",
          table_name: spa_id,
        })
        .then((res) => {
          this.nameSearch.splice(0);
          for (var i = 0; i < res.data.length; i++) {
            var item = res.data[i];
            var temp = { value: item.name };
            this.nameSearch.push(temp);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    querySearchAsync(queryString, cb) {
      var temp = this.nameSearch;
      if (queryString) {
        temp = this.nameSearch.filter(
          (item) => item.value.toUpperCase().indexOf(queryString.toUpperCase()) > -1
        );
      }
      setTimeout(() => {
        cb(temp);
      }, 200);
    },
    doInsert() {
      this.buttonDisabled = true;

      var tface = this.face;
      if (tface) {
        tface = String(tface).replaceAll("\n", "<br>");
      }
      var tbody = this.body;
      if (tbody) {
        tbody = String(tbody).replaceAll("\n", "<br>");
      }
      var tskin = this.skin;
      if (tskin) {
        tskin = String(tskin).replaceAll("\n", "<br>");
      }
      var tinteractive = this.interactive;
      if (tinteractive) {
        tinteractive = String(tinteractive).replaceAll("\n", "<br>");
      }
      var tcomment = this.comment;
      if (tcomment) {
        tcomment = String(tcomment).replaceAll("\n", "<br>");
      }
      var tmusic = this.music;
      if (tmusic) {
        tmusic = String(tmusic).replaceAll("\n", "");
      }
      var tsports = this.sports;
      if (tsports) {
        tsports = String(tsports).replaceAll("\n", "");
      }

      axios
        .post(this.tableUrl, {
          action: "insertComm",
          name: this.name,
          spa: this.spaSelected.id,
          spaName: this.spaSelected.name,
          age: this.age,
          face: tface,
          body: tbody,
          cup: this.cup,
          skin: tskin,
          interactive: tinteractive,
          comment: tcomment,
          author: this.author,
          writeDate: this.writeDate,
          music: tmusic,
          sports: tsports,
          reserveDate: this.reserveDate,
        })
        .then((res) => {
          if (!res.data.result) {
            this.getResult = this.name + " 填寫失敗<br>";
          } else {
            this.getResult = "填寫成功<br>";
            this.spaSelected = "";
            this.name = "";
            this.age = "";
            this.face = "";
            this.body = "";
            this.cup = "";
            this.skin = "";
            this.interactive = "";
            this.comment = "";
            this.author = "";
            this.music = "";
            this.sports = "";
            this.writeDate = new Date().toISOString().split("T")[0];
          }
        })
        .catch((error) => {
          console.error(error);
        });

      setTimeout(() => {
        this.buttonDisabled = false;
      }, 1000);

      setTimeout(() => {
        this.getResult = "&emsp;";
      }, 5000);
    },
  },
  created: function () {
    console.log("comm");
  },
  mounted() {
    this.selectWork3();
    this.writeDate = new Date().toISOString().split("T")[0];
  },
  watch: {
    spaSelected: function (val, oldVal) {
      this.selectName(val.id);
    },
  },
};
</script>
